import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// import html2pdf from 'html2pdf.js';
import html2pdf from 'html2pdf.js/dist/html2pdf.min.js';
// helpers
import { setPageTitle } from 'helpers';
// components
import Ticket from 'components/Ticket/Ticket';
// scss
import './TicketsPage.scss';

const TicketsPage = () => {
  const ticketsData = JSON.parse(sessionStorage.getItem('appStatetTickets'));
  const navigate = useNavigate();

  const pdfRef = useRef();

  async function generatePDF() {
    const element = pdfRef.current;

    // Отримуємо кнопки, які потрібно приховати
    const buttons = document.querySelectorAll('.data-html2canvas-ignore');
    // Додаємо клас для приховування кнопок перед створенням PDF
    buttons?.forEach(button => button.classList.add('hide-for-pdf'));

    // Налаштування для html2pdf
    const opt = {
      margin:       [0, 0, 0, 0],
      filename:     'tickets.pdf',
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas:  { scale: 2 },
      jsPDF:        { unit: 'in', format: 'a4', orientation: 'landscape' }
    };

    // Генерація PDF і відкриття його у новій вкладці
    html2pdf().from(element).set(opt).output('blob').then((pdfBlob) => {
      // Створюємо URL для відкриття у новій вкладці
      const pdfURL = URL.createObjectURL(pdfBlob);
      window.open(pdfURL, '_blank');

      // Видаляємо клас, щоб повернути кнопки до видимості
      buttons?.forEach(button => button.classList.remove('hide-for-pdf'));
    });
  }

  useEffect(() => { setPageTitle("Згенерувати квитки") }, []);
  useEffect(() => { if (ticketsData === undefined) navigate('/'); }, [ticketsData, navigate]);

  return (
    <section className="tickets">
      <div className="tickets__container container">
        <div className="tickets-content">
          <button className='tickets__btn--generatepdf ticket__btn--download' type='button' onClick={generatePDF}>Згенерувати PDF</button>

          <div className="tickets__list" ref={pdfRef}>
            {ticketsData?.reduce((acc, i, idx) => {
              // Якщо це парний індекс, створюємо новий div
              if (idx % 2 === 0) acc.push(<div className="tickets__page" key={acc.length}>{[]}</div>);
              // Додаємо компонент Ticket до останнього елемента acc
              acc[acc.length - 1].props.children.push(<Ticket key={idx} data={i} />);

              return acc;
            }, []).map((page, pageIndex) => (
              <div className="tickets__page" key={pageIndex}>
                {page.props.children}
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default TicketsPage;
